import { EventId, StateId, StateMeta } from 'components/AddCampaignModal/Types'
import { CreateCampaign } from 'components/AddCampaignModal/CreateCampaign/CreateCampaign'
import { Analysing } from 'components/AddCampaignModal/Analysing/Analysing'
import { AnalysisError } from 'components/AddCampaignModal/AnalysisError/AnalysisError'
import { Review } from 'components/AddCampaignModal/Review/Review'
import { Distribution } from 'components/AddCampaignModal/Distribution/Distribution'
import { Modal } from 'almanac-ui/Modal'
import { useCallback } from 'react'
import { ModalTitleContainer } from 'components/BatchCreateCampaignsModal/ModalLayoutProvider/ModalTitleContainer'
import { ModalBackContainer } from 'components/BatchCreateCampaignsModal/ModalLayoutProvider/ModalBackContainer'
import { AddCampaignFlowProps } from 'components/AddCampaignModal/AddCampaignFlow/Types'

export const AddCampaignFlow = ({ current, send, campaignFormRef }: AddCampaignFlowProps) => {
  const handleBack = useCallback(() => {
    send({ type: EventId.Back })
  }, [send])

  const meta = Object.values(current.meta)[0] as StateMeta

  const { anchor_content } = current.context

  const screenshotUrl = anchor_content && 'screenshot_url' in anchor_content ? anchor_content.screenshot_url : undefined

  return (
    <>
      <ModalTitleContainer>{meta.title}</ModalTitleContainer>
      {current.matches(StateId.CreateCampaign) && (
        <CreateCampaign
          ref={campaignFormRef}
          sources={current.context.sources}
          startDate={current.context.start_date}
          length={current.context.length}
          topic={current.context.topic}
          targetLink={current.context.strategy.target_link}
          anchorContent={current.context.anchor_content}
          onNext={(vars) => {
            send({ type: EventId.PrepareCampaign, ...vars })
          }}
        />
      )}
      {current.matches(StateId.Analysing) && (
        <Analysing
          anchorType="website"
          labels={['Analysing your webpage', 'Reviewing content', 'Generating campaign']}
          screenshotUrl={screenshotUrl}
        />
      )}
      {current.matches(StateId.AnalysisError) && (
        <AnalysisError
          targetLink={current.context.strategy.target_link}
          error={current.context.error}
          onNext={(vars) => {
            send({
              type: EventId.PrepareCampaign,
              topic: current.context.topic,
              startDate: current.context.start_date,
              length: current.context.length,
              targetLink: current.context.strategy.target_link,
              sources: current.context.sources,
              ...vars,
            })
          }}
        />
      )}
      {current.matches(StateId.Review) && (
        <Review
          targetLink={current.context.strategy.target_link}
          callToAction={current.context.strategy.call_to_action}
          theme={current.context.strategy.themes[0]?.title || ''}
          audience={current.context.audience}
          description={current.context.strategy.themes[0]?.description || ''}
          goal={current.context.goal}
          onNext={(vars) => {
            send({ type: EventId.ReviewComplete, ...vars })
          }}
        />
      )}
      {current.matches(StateId.Distribution) && (
        <Distribution
          videoCrosspostContents={current.context.video_crosspost_contents}
          crosspostContents={current.context.crosspost_contents}
          crosspostFrequency={current.context.crosspost_frequency}
          instagramContents={current.context.instagram_contents}
          facebookContents={current.context.facebook_contents}
          linkedinContents={current.context.linkedin_contents}
          twitterContents={current.context.twitter_contents}
          emailContents={current.context.email_contents}
          seoContents={current.context.seo_contents}
          tiktokContents={current.context.tiktok_contents}
          youtubeContents={current.context.youtube_contents}
          googleMyBusinessContents={current.context.google_my_business_contents}
          weekDays={current.context.week_days}
          tactics={current.context.tactics}
          onNext={(vars) => {
            send({ type: EventId.Finish, ...vars })
          }}
        />
      )}
      <ModalBackContainer>
        <Modal.FooterButton onPress={handleBack} size="lg" variant="tertiary">
          Back
        </Modal.FooterButton>
      </ModalBackContainer>
    </>
  )
}
